export const parseCommaSeparatedValues = (value) => {
    if (!value)
        return [];
    return value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean);
};
